<div class="card card-size my-0">
  <div class="card-header text-center bg-black">
    <img alt="" class="" height="62" src="assets/img/main-logo.svg">
  </div>
  <div class="card-body">
    <p class="text-center mb-24px">You belong to multiple companies.
      <br>Please select a company.</p>
    <ul class="companies-container">
      <li *ngIf="companies.includes(Company.Sea)" class="mb-24px">
        <div (click)="selectCompany(Company.Sea)" class="pointer">
          <img alt="usa flag image" class="flag" src="assets/img/usa-flag.jpg">
          <span class="ml-24px">SEA</span>
          <span class="f-right">C310</span>
        </div>
      </li>
      <li *ngIf="companies.includes(Company.SeaIm)" class="mb-24px">
        <div (click)="selectCompany(Company.SeaIm)" class="pointer">
          <img alt="usa flag image" class="flag" src="assets/img/usa-flag.jpg">
          <span class="ml-24px">SEA MX</span>
          <span class="f-right">C370</span>
        </div>
      </li>
      <li *ngIf="companies.includes(Company.Seca)">
        <div (click)="selectCompany(Company.Seca)" class="pointer">
          <img alt="canada flag image" class="flag" src="assets/img/canada-flag.jpg">
          <span class="ml-24px">SECA</span>
          <span class="f-right">C330</span>
        </div>
      </li>
    </ul>
  </div>
</div>






















